const func = $target => {

    $('#confirmAllData').change(function() {

        if($(this).is(':checked')) {
            $('[id*="projectConsents-"]').prop('checked', true);
        } else {
            $('[id*="projectConsents-"]').prop('checked', false);
        }
    });

};

export default func;